import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { FinancePanel } from "@/client/modules/minhas-financas/finance-panel";
import Loading from "@/client/modules/minhas-financas/loading";

type Search = { year?: string; month?: string };

export const Route = createFileRoute("/app/minhas-financas")({
  validateSearch: (s: Record<string, unknown>): Search => ({
    year: s.year as string | undefined,
    month: s.month as string | undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("minhas-financas", "page", deps)),
  head: () => pageHead("Minhas finanças"),
  pendingComponent: Loading,
  component: MinhasFinancasPage,
});

function MinhasFinancasPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("minhas-financas", "page", search);
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Minhas finanças" description="Controle pessoal de receitas, gastos e investimentos." />
      <FinancePanel {...data} />
    </div>
  );
}
